import { SettingsIcon } from "@aureskonnect/react-ui";
import classnames from "classnames";
import React, { useCallback, useMemo } from "react";
import { Tooltip, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import {
    setIsModalApkOpened,
    setIsModalOpened,
    setIuudApk,
    store,
} from "./store";
import { store as useStore } from "@components/VerticalLayout/store";
import ConsultSvgIcon from "@components/Common/SvgIcons/ConsultSvgIcon";
import { InfoToast } from "@components/Common/ErrorTost";
import { getDataShop } from "./ModalWrapper/hooks";
import { useFetchGlobal } from "../../../../api/hooks";

export default function CustomIcons({
    e,
    setSelectedRows,
    setMergedData,
    setIsFetchingData,
}: any) {
    const { selectedRow } = e;
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const { isModalApkOpened, modify } = useSnapshot(store);
    const { franchiseID, userID } = useSnapshot(useStore);
    const { oneShop } = useSnapshot(useStore);
    let isConsultDisabled = !oneShop && e.selectedRow[t("Apk")];
    let isDisabled =
        selectedRow["application"] === false && selectedRow["Web site"] === 0;

    const consultClassName = useMemo(
        () =>
            classnames("pointer__clz afa_icn_toConsult ml-2", {
                "not-allowed-icon__clz": isConsultDisabled,
            }),
        [isConsultDisabled]
    );

    const handleSettingsClick = useCallback(async () => {
        setSelectedRows([selectedRow]);
        let listapk = selectedRow.iuudApk;
        if (isDisabled) {
            InfoToast(
                t(
                    "Please note you cannot access this parameter. The app and site are disabled."
                )!
            );
        } else {
            if (listapk.length === 1) {
                setIuudApk(listapk[0].iuud);
                await getDataShop(
                    listapk[0].iuud,
                    selectedRow,
                    franchiseID,
                    userID,
                    setMergedData,
                    setIsFetchingData,
                    fetchGlobal
                );
                setIsModalOpened(true);
            } else {
                setIsModalApkOpened(!isModalApkOpened);
            }
        }
    }, [
        selectedRow,
        isDisabled,
        isModalApkOpened,
        setSelectedRows,
        t,
        franchiseID,
        userID,
        setMergedData,
        setIsFetchingData,
        fetchGlobal,
    ]);

    const handleConsultClick = useCallback(() => {
        setIsModalApkOpened(!isModalApkOpened);
        setSelectedRows([selectedRow]);
    }, [selectedRow, isModalApkOpened, setSelectedRows]);

    if (modify) {
        return (
            <>
                <Tooltip title={t("configure")}>
                    <IconButton onClick={handleSettingsClick}>
                        <SettingsIcon
                            className={`${classnames("pointer__clz ml-3", {})}`}
                            height={22}
                            width={22}
                        />
                    </IconButton>
                </Tooltip>
            </>
        );
    }
    return (
        <React.Fragment>
            <div>
                <Tooltip title={t("To consult")}>
                    <IconButton onClick={handleConsultClick}>
                        <ConsultSvgIcon
                            className={consultClassName}
                            height={35}
                            width={35}
                            style={{
                                cursor: "pointer",
                                position: "relative",
                                bottom: "5px",
                            }}
                            fill="black"
                        />
                    </IconButton>
                </Tooltip>
            </div>
        </React.Fragment>
    );
}
